import { isArray } from 'lodash';
import {
  Attribute,
  BlobData,
  CategoryResult,
  CodeInfo,
  CdCodeInfo,
  GetTemplateCompany,
  GetCompanyInfo,
  Criteria,
  DocumentData,
  GetAccountsInfo,
  GetCategoryMaster,
  GetConfirmedInspection,
  GetConfirmedQc,
  GetFCodeMaster,
  GetInspectionItem,
  GetInspectionTop,
  GetInspectionType,
  GetItemMaster,
  GetItemModelCriteria,
  GetItemModelCriteriaMaster,
  GetMarketCodeList,
  GetModelNameList,
  GetNgSample,
  GetOperationHistory,
  GetPartsInfo,
  GetPartsSelection,
  GetPCodeMaster,
  GetPFRCodeTableRow,
  GetQcTypeList,
  GetRCodeMaster,
  GetRCodePartsMaster,
  GetRepairRequest,
  GetRepairRequestList,
  GetReport,
  GetTemplateMaster,
  GetTypeLabelList,
  GetTypeMaster,
  GetUserInfo,
  ItemMaster,
  ItemResult,
  JudgementData,
  MarkerInfo,
  PartNoList,
  Question,
  TypeResult,
  CategoryMaster,
  TypeMaster,
  GetQcType,
  CompanyKeyName,
  GetReportFormat,
  GetTemplateItemMaster,
  GetTemplateCategory,
  GetTemplateType,
  GetTemplateItem,
  PFRCodeName,
} from '../services/apiTypes';

// 型ガード関数の定義ファイル

export function isGetRepairRequest(data: any): data is GetRepairRequest {
  return (
    data &&
    typeof data.rmaNo === 'string' &&
    typeof data.status === 'number' &&
    typeof data.serialNo === 'string' &&
    typeof data.model === 'string' &&
    isModelInfo(data.modelInfo) &&
    typeof data.customerName === 'string' &&
    (typeof data.scopeConnectionCount === 'number' ||
      data.scopeConnectionCount === null) &&
    typeof data.ownership === 'string' &&
    typeof data.installDate === 'string' &&
    typeof data.originalCustomer === 'string' &&
    typeof data.customerComment === 'string' &&
    typeof data.warrantyEndDate === 'string' &&
    typeof data.contract === 'string' &&
    typeof data.serviceType === 'string' &&
    typeof data.contractEndDate === 'string' &&
    typeof data.customerPriority === 'string' &&
    typeof data.companyKey === 'string' &&
    typeof data.isCreatedByExFM === 'boolean' &&
    typeof data.exFMUrl === 'string' &&
    typeof data.linkedInspectionToExFM === 'boolean' &&
    typeof data.linkedQcToExFM === 'boolean'
  );
}

function isModelInfo(data: any) {
  return (
    data &&
    (typeof data.attributeId1 === 'number' || data.attributeId1 === null) &&
    (typeof data.attributeId2 === 'number' || data.attributeId2 === null) &&
    (typeof data.attributeId3 === 'number' || data.attributeId3 === null) &&
    (typeof data.attributeId5 === 'number' || data.attributeId5 === null) &&
    (typeof data.attributeId6 === 'number' || data.attributeId6 === null) &&
    (typeof data.brandId === 'number' || data.brandId === null)
  );
}

export function isGetRepairRequestList(
  data: any,
): data is GetRepairRequestList {
  return (
    data &&
    typeof data.totalRows === 'number' &&
    isArray(data.repairRequestList) &&
    data.repairRequestList.every((e: any) => isRepairRequestList(e))
  );
}

function isRepairRequestList(data: any): data is GetRepairRequestList {
  return (
    data &&
    typeof data.rmaNo === 'string' &&
    typeof data.status === 'number' &&
    typeof data.serialNo === 'string' &&
    typeof data.model === 'string' &&
    typeof data.inspectorName === 'string' &&
    typeof data.customerName === 'string' &&
    typeof data.distributor === 'string' &&
    typeof data.startDate === 'string' &&
    typeof data.endDate === 'string' &&
    typeof data.isSerialChecked === 'boolean' &&
    typeof data.companyKey === 'string'
  );
}

export function isGetInspectionTop(data: any): data is GetInspectionTop {
  return (
    data &&
    typeof data.rmaNo === 'string' &&
    typeof data.inspectorName === 'string' &&
    (typeof data.selectedInspectionTypeId === 'number' ||
      data.selectedInspectionTypeId === null) &&
    isArray(data.inspectionTypeList) &&
    data.inspectionTypeList.every((e: any) => isInspectionTypeList(e)) &&
    typeof data.selectedCategoryId === 'string' &&
    isArray(data.partsCategoryList) &&
    data.partsCategoryList.every((e: any) => isPartsCategoryList(e)) &&
    isArray(data.inspectionCategoryList) &&
    data.inspectionCategoryList.every((e: any) =>
      isInspectionCategoryList(e),
    ) &&
    typeof data.qcCount === 'number' &&
    typeof data.isSerialChecked === 'boolean'
  );
}

function isInspectionTypeList(data: any) {
  return (
    data &&
    typeof data.id === 'number' &&
    typeof data.name === 'string' &&
    typeof data.templateClass === 'number'
  );
}

function isPartsCategoryList(data: any) {
  return data && typeof data.id === 'string' && typeof data.name === 'string';
}

function isInspectionCategoryList(data: any) {
  return (
    data &&
    typeof data.id === 'string' &&
    typeof data.label === 'string' &&
    typeof data.progress === 'number'
  );
}

export function isGetTypeLabelList(data: any): data is GetTypeLabelList {
  return (
    data &&
    isArray(data) &&
    data.every(
      (e: any) => typeof e.id === 'string' && typeof e.label === 'string',
    )
  );
}

export function isGetInspectionType(data: any): data is GetInspectionType {
  return (
    data &&
    typeof data.rmaNo === 'string' &&
    typeof data.categoryId === 'string' &&
    typeof data.typeId === 'string' &&
    typeof data.manualPath === 'string' &&
    typeof data.memo === 'string' &&
    typeof data.isVisualInspection === 'boolean' &&
    typeof data.displayType === 'number' &&
    isArray(data.markers) &&
    isArray(data.ngSample) &&
    isArray(data.itemData) &&
    data.markers.every((e: any) => isMarkerInfo(e)) &&
    data.ngSample.every((e: any) => isGetNgSample(e)) &&
    data.itemData.every((e: any) => isGetInspectionItem(e))
  );
}

function isGetNgSample(data: any): data is GetNgSample {
  return (
    data &&
    typeof data.index === 'number' &&
    typeof data.label === 'string' &&
    typeof data.path === 'string'
  );
}

function isGetInspectionItem(data: any): data is GetInspectionItem {
  return (
    data &&
    typeof data.id === 'string' &&
    typeof data.label === 'string' &&
    typeof data.judgement === 'number' &&
    typeof data.inputType === 'number' &&
    isCriteria(data.criteria) &&
    (typeof data.numericalValue === 'number' || data.numericalValue === null) &&
    (typeof data.memo === 'string' || data.memo === null) &&
    isArray(data.itemData) &&
    data.itemData.every((e: any) => isGetInspectionItem(e))
  );
}

export function isGetConfirmedInspection(
  data: any,
): data is GetConfirmedInspection {
  return (
    data &&
    typeof data.rmaNo === 'string' &&
    (typeof data.repairType === 'number' || data.repairType === null) &&
    typeof data.serviceType === 'string' &&
    typeof data.evaluationResults === 'string' &&
    typeof data.notesToCustomer === 'string' &&
    isArray(data.questions) &&
    data.questions.every((e: any) => isQuestion(e)) &&
    isArray(data.repairTypeList) &&
    data.repairTypeList.every((e: any) => isRepairType(e)) &&
    isArray(data.serviceTypeList) &&
    data.serviceTypeList.every((e: any) => isServiceType(e)) &&
    isArray(data.documents) &&
    data.documents.every((e: any) => isDocumentData(e)) &&
    isArray(data.cdCodeList) &&
    data.cdCodeList.every((e: any) => isCdCodeInfo(e)) &&
    isPFRCodeList(data.pfrCodeList) &&
    isIsaReplacement(data.isaReplacement)
  );
}

function isQuestion(data: any): data is Question {
  return (
    data &&
    typeof data.id === 'number' &&
    typeof data.answer === 'string' &&
    typeof data.memo === 'string'
  );
}

function isRepairType(data: any) {
  return data && typeof data.id === 'number' && typeof data.name === 'string';
}

function isServiceType(data: any) {
  return data && typeof data.id === 'string' && typeof data.name === 'string';
}

function isDocumentData(data: any): data is DocumentData {
  return (
    data &&
    typeof data.id === 'number' &&
    typeof data.imagePath === 'string' &&
    typeof data.documentPath === 'string' &&
    typeof data.comment === 'string'
  );
}

function isPFRCodeList(data: any) {
  return (
    data &&
    isArray(data.before) &&
    data.before.every((e: any) => isGetPFRCodeTableRow(e)) &&
    isArray(data.after) &&
    data.after.every((e: any) => isGetPFRCodeTableRow(e))
  );
}

function isGetPFRCodeTableRow(data: any): data is GetPFRCodeTableRow {
  return (
    data &&
    typeof data.itemId === 'string' &&
    typeof data.index === 'number' &&
    typeof data.categoryName === 'string' &&
    typeof data.typeName === 'string' &&
    isItemName(data.itemName) &&
    isCodeInfo(data.p) &&
    isCodeInfo(data.f) &&
    isCodeInfo(data.r) &&
    isArray(data.rList) &&
    data.rList.every((e: any) => isCodeInfo(e)) &&
    typeof data.reportedByCustomer === 'boolean' &&
    isCdCodeInfo(data.cd)
  );
}

function isItemName(data: any) {
  return (
    data &&
    typeof data.depth0 === 'string' &&
    (typeof data.depth1 === 'string' || data.depth1 === null) &&
    (typeof data.depth2 === 'string' || data.depth2 === null)
  );
}

export function isGetConfirmedQc(data: any): data is GetConfirmedQc {
  return (
    data &&
    typeof data.rmaNo === 'string' &&
    isArray(data.pfCodeList) &&
    data.pfCodeList.every((e: any) => isPFCodeList(e))
  );
}

function isPFCodeList(data: any) {
  return data && isCodeInfo(data.p) && isCodeInfo(data.f);
}

export function isGetPartsSelection(data: any): data is GetPartsSelection {
  return (
    data &&
    typeof data.rmaNo === 'string' &&
    typeof data.marketCode === 'number' &&
    isArray(data.rList) &&
    data.rList.every((e: any) => isRList(e))
  );
}

function isRList(data: any) {
  return (
    data &&
    typeof data.index === 'number' &&
    isCodeInfo(data.r) &&
    isArray(data.partsInfo) &&
    data.partsInfo.every((e: any) => isGetPartsInfo(e))
  );
}

function isCodeInfo(data: any): data is CodeInfo {
  return (
    data && typeof data.code === 'string' && typeof data.detail === 'string'
  );
}

function isCdCodeInfo(data: any): data is CdCodeInfo {
  return data && typeof data.code === 'string' && typeof data.name === 'string';
}

function isIsaReplacement(
  data: any,
): data is { main: CodeInfo; sub: CodeInfo } {
  return data && isCodeInfo(data.main) && isCodeInfo(data.sub);
}

function isGetPartsInfo(data: any): data is GetPartsInfo {
  return (
    data &&
    typeof data.listNo === 'string' &&
    typeof data.inFigureNo === 'string' &&
    typeof data.partsAttribute === 'string' &&
    typeof data.isSelect === 'boolean' &&
    typeof data.selectedPartsCode === 'string' &&
    isArray(data.partsList) &&
    data.partsList.every((e: any) => isPartsList(e)) &&
    typeof data.amount === 'number' &&
    typeof data.section === 'string' &&
    typeof data.keyNo === 'string' &&
    typeof data.ecnNo === 'string' &&
    typeof data.isometricDrawing === 'string'
  );
}

function isPartsList(data: any) {
  return (
    data && typeof data.partsCode === 'string' && typeof data.name === 'string'
  );
}

export function isJudgementData(data: any): data is JudgementData {
  return (
    data &&
    typeof data.rmaNo === 'string' &&
    typeof data.empty === 'number' &&
    typeof data.ok === 'number' &&
    typeof data.ng === 'number' &&
    typeof data.na === 'number'
  );
}

export function isGetCategoryMaster(data: any): data is GetCategoryMaster {
  return data && isArray(data) && data.every((e) => isCategoryMaster(e));
}

function isCategoryMaster(data: any): data is CategoryMaster {
  return (
    data &&
    typeof data.categoryId === 'string' &&
    typeof data.displayName === 'string' &&
    typeof data.categoryName === 'string' &&
    typeof data.categoryNameJp === 'string' &&
    typeof data.categoryName03 === 'string' &&
    typeof data.categoryName04 === 'string' &&
    typeof data.categoryName05 === 'string' &&
    typeof data.categoryName06 === 'string' &&
    typeof data.categoryName07 === 'string' &&
    typeof data.categoryName08 === 'string' &&
    typeof data.categoryName09 === 'string' &&
    typeof data.categoryName10 === 'string' &&
    typeof data.sort === 'number' &&
    typeof data.isOptionalAddition === 'boolean'
  );
}

export function isGetTypeMaster(data: any): data is GetTypeMaster {
  return data && isArray(data) && data.every((e) => isTypeMaster(e));
}

function isTypeMaster(data: any): data is TypeMaster {
  return (
    data &&
    typeof data.categoryId === 'string' &&
    typeof data.typeId === 'string' &&
    typeof data.displayName === 'string' &&
    typeof data.typeName === 'string' &&
    typeof data.typeNameJp === 'string' &&
    typeof data.typeName03 === 'string' &&
    typeof data.typeName04 === 'string' &&
    typeof data.typeName05 === 'string' &&
    typeof data.typeName06 === 'string' &&
    typeof data.typeName07 === 'string' &&
    typeof data.typeName08 === 'string' &&
    typeof data.typeName09 === 'string' &&
    typeof data.typeName10 === 'string' &&
    typeof data.sort === 'number' &&
    typeof data.isOptionalAddition === 'boolean' &&
    typeof data.isVisualInspection === 'boolean' &&
    typeof data.displayType === 'number' &&
    typeof data.documentPath === 'string' &&
    typeof data.memo === 'string' &&
    isArray(data.typeImageMaster) &&
    data.typeImageMaster.every((e: any) => isTypeImageMaster(e))
  );
}

function isTypeImageMaster(data: any) {
  return (
    data &&
    typeof data.imageNo === 'number' &&
    typeof data.labelName === 'string' &&
    typeof data.labelNameJp === 'string' &&
    typeof data.labelName03 === 'string' &&
    typeof data.labelName04 === 'string' &&
    typeof data.labelName05 === 'string' &&
    typeof data.labelName06 === 'string' &&
    typeof data.labelName07 === 'string' &&
    typeof data.labelName08 === 'string' &&
    typeof data.labelName09 === 'string' &&
    typeof data.labelName10 === 'string' &&
    typeof data.imagePath === 'string' &&
    typeof data.sort === 'number'
  );
}

export function isGetItemMaster(data: any): data is GetItemMaster {
  return (
    data &&
    isArray(data.attribute1MasterList) &&
    isArray(data.attribute2MasterList) &&
    isArray(data.attribute3MasterList) &&
    isArray(data.attribute5MasterList) &&
    isArray(data.attribute6MasterList) &&
    isArray(data.pCodeMasterList) &&
    isArray(data.fCodeMasterList) &&
    isArray(data.rCodeMasterList) &&
    isArray(data.brandMasterList) &&
    isArray(data.itemList) &&
    data.attribute1MasterList.every((e: any) => isAttribute(e)) &&
    data.attribute2MasterList.every((e: any) => isAttribute(e)) &&
    data.attribute3MasterList.every((e: any) => isAttribute(e)) &&
    data.attribute5MasterList.every((e: any) => isAttribute(e)) &&
    data.attribute6MasterList.every((e: any) => isAttribute(e)) &&
    data.pCodeMasterList.every((e: any) => isPFRCodeNames(e)) &&
    data.fCodeMasterList.every((e: any) => isPFRCodeNames(e)) &&
    data.rCodeMasterList.every((e: any) => isPFRCodeNames(e)) &&
    data.brandMasterList.every((e: any) => isAttribute(e)) &&
    data.itemList.every((e: any) => isItemMaster(e))
  );
}

function isAttribute(data: any): data is Attribute {
  return data && typeof data.id === 'number' && typeof data.name === 'string';
}

function isPFRCodeNames(data: any): data is PFRCodeName {
  return data && typeof data.code === 'string' && typeof data.name === 'string';
}

function isItemMaster(data: any): data is ItemMaster {
  return (
    data &&
    typeof data.categoryId === 'string' &&
    typeof data.typeId === 'string' &&
    typeof data.itemId === 'string' &&
    typeof data.displayName === 'string' &&
    typeof data.itemName === 'string' &&
    typeof data.itemNameJp === 'string' &&
    typeof data.itemName03 === 'string' &&
    typeof data.itemName04 === 'string' &&
    typeof data.itemName05 === 'string' &&
    typeof data.itemName06 === 'string' &&
    typeof data.itemName07 === 'string' &&
    typeof data.itemName08 === 'string' &&
    typeof data.itemName09 === 'string' &&
    typeof data.itemName10 === 'string' &&
    typeof data.depth === 'number' &&
    typeof data.inputType === 'number' &&
    (typeof data.parentItemId === 'string' || data.parentItemId === null) &&
    isCriteria(data.criteria) &&
    (typeof data.sort === 'number' || data.sort === null) &&
    typeof data.isOptionalAddition === 'boolean' &&
    isArray(data.selectedAttribute1) &&
    isArray(data.selectedAttribute2) &&
    isArray(data.selectedAttribute3) &&
    isArray(data.selectedAttribute5) &&
    isArray(data.selectedAttribute6) &&
    isArray(data.selectedBrandName) &&
    data.selectedAttribute1.every((e: any) => isAttribute(e)) &&
    data.selectedAttribute2.every((e: any) => isAttribute(e)) &&
    data.selectedAttribute3.every((e: any) => isAttribute(e)) &&
    data.selectedAttribute5.every((e: any) => isAttribute(e)) &&
    data.selectedAttribute6.every((e: any) => isAttribute(e)) &&
    data.selectedBrandName.every((e: any) => isAttribute(e)) &&
    typeof data.selectedConditions === 'string' &&
    typeof data.pCode === 'string' &&
    typeof data.fCode === 'string' &&
    isArray(data.rCodeList) &&
    data.rCodeList.every((e: any) => typeof e === 'string') &&
    typeof data.memo === 'string'
  );
}

export function isGetTemplateMaster(data: any): data is GetTemplateMaster {
  return (
    data &&
    isArray(data.companyMasterList) &&
    isArray(data.templateList) &&
    data.companyMasterList.every((e: any) => isCompanyMaster(e)) &&
    data.templateList.every((e: any) => isTemplate(e))
  );
}

function isCompanyMaster(data: any) {
  return (
    data &&
    typeof data.companyKey === 'string' &&
    typeof data.companyName === 'string' &&
    typeof data.agencyType === 'string' &&
    typeof data.primaryAgency === 'string'
  );
}

function isTemplate(data: any) {
  return (
    data &&
    typeof data.templateId === 'number' &&
    typeof data.inspectionClass === 'number' &&
    typeof data.templateClass === 'number' &&
    typeof data.documentNo === 'string' &&
    typeof data.effectiveDate === 'string' &&
    typeof data.isReadOnly === 'boolean' &&
    typeof data.displayName === 'string' &&
    typeof data.templateName === 'string' &&
    typeof data.templateNameJp === 'string' &&
    typeof data.templateName03 === 'string' &&
    typeof data.templateName04 === 'string' &&
    typeof data.templateName05 === 'string' &&
    typeof data.templateName06 === 'string' &&
    typeof data.templateName07 === 'string' &&
    typeof data.templateName08 === 'string' &&
    typeof data.templateName09 === 'string' &&
    typeof data.templateName10 === 'string' &&
    isArray(data.selectedCompanyList) &&
    data.selectedCompanyList.every((e: any) => isTemplateCompany(e))
  );
}

function isTemplateCompany(data: any): data is GetTemplateCompany {
  return (
    data &&
    typeof data.companyKey === 'string' &&
    typeof data.companyName === 'string'
  );
}

export function isGetTemplateItemMaster(
  data: any,
): data is GetTemplateItemMaster {
  return (
    data &&
    isArray(data) &&
    data.every((e: any) => e && isGetTemplateCategory(e))
  );
}

function isGetTemplateCategory(data: any): data is GetTemplateCategory {
  return (
    data &&
    typeof data.categoryId === 'string' &&
    typeof data.categoryName === 'string' &&
    isArray(data.typeList) &&
    data.typeList.every((e: any) => e && isGetTemplateType(e))
  );
}

function isGetTemplateType(data: any): data is GetTemplateType {
  return (
    data &&
    typeof data.typeId === 'string' &&
    typeof data.typeName === 'string' &&
    isArray(data.itemList) &&
    data.itemList.every((e: any) => e && isGetTemplateItem(e))
  );
}

function isGetTemplateItem(data: any): data is GetTemplateItem {
  return (
    data &&
    typeof data.isSelect === 'boolean' &&
    typeof data.itemId === 'string' &&
    typeof data.itemName === 'string' &&
    isArray(data.itemList) &&
    data.itemList.every((e: any) => e && isGetTemplateItem(e))
  );
}

export function isGetUserInfoList(data: any): data is GetUserInfo[] {
  return data && isArray(data) && data.every((e: any) => isGetUserInfo(e));
}

export function isGetUserInfo(data: any): data is GetUserInfo {
  return (
    data &&
    typeof data.userId === 'string' &&
    typeof data.name === 'string' &&
    typeof data.roleId === 'number' &&
    typeof data.companyKey === 'string' &&
    typeof data.language === 'string' &&
    typeof data.isLocked === 'boolean' &&
    typeof data.dateFormat === 'number' &&
    typeof data.partsListDisplayPattern === 'number'
  );
}

export function isGetQcType(data: any): data is GetQcType {
  return (
    data && isGetInspectionType(data.before) && isGetInspectionType(data.after)
  );
}

export function isGetQcTypeList(data: any): data is GetQcTypeList {
  return (
    data &&
    isArray(data.before) &&
    isArray(data.after) &&
    data.before.every((e: any) => isGetInspectionType(e)) &&
    data.after.every((e: any) => isGetInspectionType(e))
  );
}

export function isGetReport(data: any): data is GetReport {
  return (
    data &&
    typeof data.rmaNo === 'string' &&
    typeof data.serialNo === 'string' &&
    typeof data.model === 'string' &&
    typeof data.customerName === 'string' &&
    typeof data.originalCustomer === 'string' &&
    typeof data.inspector === 'string' &&
    typeof data.qcInspector === 'string' &&
    typeof data.inspectionDate === 'string' &&
    typeof data.qcDate === 'string' &&
    typeof data.isInspectionSerialChecked === 'boolean' &&
    typeof data.isQcSerialChecked === 'boolean' &&
    typeof data.documentNo === 'string' &&
    typeof data.effectiveDate === 'string' &&
    typeof data.memo === 'string' &&
    isArray(data.inspectionResultList) &&
    isArray(data.qcResultList) &&
    isArray(data.markers) &&
    isArray(data.filepaths) &&
    data.inspectionResultList.every((e: any) => isCategoryResult(e)) &&
    data.qcResultList.every((e: any) => isCategoryResult(e)) &&
    data.markers.every((e: any) => isMarkerInfo(e)) &&
    data.filepaths.every((e: any) => typeof e === 'string')
  );
}

export function isGetReportFormat(data: any): data is GetReportFormat {
  return (
    data &&
    typeof data.documentNo === 'string' &&
    typeof data.effectiveDate === 'string' &&
    isArray(data.resultList) &&
    data.resultList.every((e: any) => isCategoryResult(e))
  );
}

function isCategoryResult(data: any): data is CategoryResult {
  return (
    data &&
    typeof data.categoryId === 'string' &&
    typeof data.label === 'string' &&
    isArray(data.typeResultList) &&
    data.typeResultList.every((e: any) => isTypeResult(e))
  );
}

function isTypeResult(data: any): data is TypeResult {
  return (
    data &&
    typeof data.typeId === 'string' &&
    typeof data.label === 'string' &&
    isArray(data.itemResultList) &&
    data.itemResultList.every((e: any) => isItemResult(e))
  );
}

function isItemResult(data: any): data is ItemResult {
  return (
    data &&
    typeof data.itemId === 'string' &&
    typeof data.label === 'string' &&
    typeof data.judgement === 'number' &&
    (typeof data.numericalValue === 'number' || data.numericalValue === null) &&
    isArray(data.itemResultList) &&
    data.itemResultList.every((e: any) => isItemResult(e))
  );
}

function isMarkerInfo(data: any): data is MarkerInfo {
  return (
    data &&
    typeof data.id === 'number' &&
    typeof data.x === 'number' &&
    typeof data.y === 'number' &&
    (typeof data.memo === 'string' || data.memo === null)
  );
}

export function isGetAccountsInfo(data: any): data is GetAccountsInfo {
  return (
    data &&
    isArray(data.marketCodeList) &&
    isArray(data.companyList) &&
    data.marketCodeList.every((e: any) => isMarketCode(e)) &&
    data.companyList.every((e: any) => isCompanyInfo(e))
  );
}

export function isGetMarketCodeList(data: any): data is GetMarketCodeList {
  return data && isArray(data) && data.every((e: any) => isMarketCode(e));
}

function isMarketCode(data: any): data is GetMarketCodeList {
  return data && typeof data.code === 'number' && typeof data.name === 'string';
}

function isCompanyInfo(data: any): data is GetCompanyInfo {
  return (
    data &&
    typeof data.key === 'string' &&
    typeof data.name === 'string' &&
    typeof data.nameJp === 'string' &&
    typeof data.name03 === 'string' &&
    typeof data.name04 === 'string' &&
    typeof data.name05 === 'string' &&
    typeof data.name06 === 'string' &&
    typeof data.name07 === 'string' &&
    typeof data.name08 === 'string' &&
    typeof data.name09 === 'string' &&
    typeof data.name10 === 'string' &&
    typeof data.selectedMarketCode === 'number' &&
    typeof data.shortName === 'string' &&
    typeof data.isSkipQC === 'boolean' &&
    isCompanyKeyName(data.primaryAgency) &&
    isArray(data.partnerCompanyList) &&
    data.partnerCompanyList.every((e: any) => isCompanyKeyName(e))
  );
}

function isCompanyKeyName(data: any): data is CompanyKeyName {
  return (
    data &&
    typeof data.companyKey === 'string' &&
    typeof data.companyName === 'string'
  );
}

export function isGetBlobData(data: any): data is BlobData[] {
  return data && isArray(data) && data.every((e: any) => isBlobData(e));
}

function isBlobData(data: any): data is BlobData {
  return data && typeof data.path === 'string' && typeof data.data === 'string';
}

export function isGetPCodeMaster(data: any): data is GetPCodeMaster[] {
  return data && isArray(data) && data.every((e: any) => isPCodeMaster(e));
}

function isPCodeMaster(data: any): data is GetPCodeMaster {
  return (
    data &&
    typeof data.code === 'string' &&
    typeof data.groupCode === 'string' &&
    typeof data.name === 'string' &&
    typeof data.jName === 'string' &&
    typeof data.eName === 'string' &&
    typeof data.eName101 === 'string' &&
    typeof data.eName102 === 'string' &&
    typeof data.eName103 === 'string' &&
    typeof data.eName104 === 'string' &&
    typeof data.eName105 === 'string' &&
    typeof data.eName106 === 'string' &&
    typeof data.eName107 === 'string' &&
    typeof data.eName108 === 'string' &&
    typeof data.eName109 === 'string' &&
    typeof data.eName110 === 'string' &&
    typeof data.createTime === 'string' &&
    typeof data.createUser === 'string' &&
    typeof data.updateTime === 'string' &&
    typeof data.updateUser === 'string'
  );
}

export function isGetFCodeMaster(data: any): data is GetFCodeMaster[] {
  return data && isArray(data) && data.every((e: any) => isFCodeMaster(e));
}

function isFCodeMaster(data: any): data is GetFCodeMaster {
  return (
    data &&
    typeof data.code === 'string' &&
    typeof data.groupCode === 'string' &&
    typeof data.name === 'string' &&
    typeof data.jName === 'string' &&
    typeof data.eName === 'string' &&
    typeof data.eName101 === 'string' &&
    typeof data.eName102 === 'string' &&
    typeof data.eName103 === 'string' &&
    typeof data.eName104 === 'string' &&
    typeof data.eName105 === 'string' &&
    typeof data.eName106 === 'string' &&
    typeof data.eName107 === 'string' &&
    typeof data.eName108 === 'string' &&
    typeof data.eName109 === 'string' &&
    typeof data.eName110 === 'string' &&
    typeof data.createTime === 'string' &&
    typeof data.createUser === 'string' &&
    typeof data.updateTime === 'string' &&
    typeof data.updateUser === 'string'
  );
}

export function isGetRCodeMaster(data: any): data is GetRCodeMaster[] {
  return data && isArray(data) && data.every((e: any) => isRCodeMaster(e));
}

function isRCodeMaster(data: any): data is GetRCodeMaster {
  return (
    data &&
    typeof data.code === 'string' &&
    typeof data.groupCode === 'string' &&
    typeof data.name === 'string' &&
    typeof data.jName === 'string' &&
    typeof data.eName === 'string' &&
    (typeof data.repairHours === 'number' || data.repairHours === null) &&
    (typeof data.listPrice === 'number' || data.listPrice === null) &&
    (typeof data.middleCost === 'number' || data.middleCost === null) &&
    (typeof data.cost === 'number' || data.cost === null) &&
    (typeof data.partCost === 'number' || data.partCost === null) &&
    (typeof data.gRepairHours === 'number' || data.gRepairHours === null) &&
    (typeof data.gListPrice === 'number' || data.gListPrice === null) &&
    (typeof data.gMiddleCost === 'number' || data.gMiddleCost === null) &&
    (typeof data.gCost === 'number' || data.gCost === null) &&
    (typeof data.gPartCost === 'number' || data.gPartCost === null) &&
    typeof data.eName101 === 'string' &&
    typeof data.eName102 === 'string' &&
    typeof data.eName103 === 'string' &&
    typeof data.eName104 === 'string' &&
    typeof data.eName105 === 'string' &&
    typeof data.eName106 === 'string' &&
    typeof data.eName107 === 'string' &&
    typeof data.eName108 === 'string' &&
    typeof data.eName109 === 'string' &&
    typeof data.eName110 === 'string' &&
    typeof data.createTime === 'string' &&
    typeof data.createUser === 'string' &&
    typeof data.updateTime === 'string' &&
    typeof data.updateUser === 'string'
  );
}

export function isGetRCodePartsMaster(
  data: any,
): data is GetRCodePartsMaster[] {
  return data && isArray(data) && data.every((e: any) => isRCodePartsMaster(e));
}

function isRCodePartsMaster(data: any): data is GetRCodePartsMaster {
  return (
    data &&
    typeof data.modelName === 'string' &&
    typeof data.category === 'string' &&
    typeof data.listNo === 'string' &&
    typeof data.listVersion === 'number' &&
    typeof data.inFigureNo === 'string' &&
    typeof data.partNo === 'string' &&
    typeof data.ePartName === 'string' &&
    (typeof data.amount === 'number' || data.amount === null) &&
    typeof data.mfwInfo === 'string' &&
    typeof data.ecnNo === 'string' &&
    typeof data.rCode === 'string' &&
    typeof data.rCodeName === 'string' &&
    typeof data.erCodeName === 'string' &&
    typeof data.createTime === 'string' &&
    typeof data.createUser === 'string' &&
    typeof data.updateTime === 'string' &&
    typeof data.updateUser === 'string'
  );
}

export function isGetItemModelCriteriaMaster(
  data: any,
): data is GetItemModelCriteriaMaster {
  return (
    data &&
    isArray(data.itemMasterList) &&
    isArray(data.modelNameList) &&
    isArray(data.itemModelCriteriaList) &&
    data.itemMasterList.every((e: any) => isItemMasterList(e)) &&
    data.modelNameList.every((e: any) => typeof e === 'string') &&
    data.itemModelCriteriaList.every((e: any) => isGetItemModelCriteria(e))
  );
}

function isItemMasterList(data: any) {
  return (
    data && typeof data.itemId === 'string' && typeof data.itemName === 'string'
  );
}

function isGetItemModelCriteria(data: any): data is GetItemModelCriteria {
  return (
    data &&
    typeof data.modelName === 'string' &&
    typeof data.itemId === 'string' &&
    isCriteria(data.criteria)
  );
}

function isCriteria(data: any): data is Criteria {
  return (
    data &&
    typeof data.text === 'string' &&
    (typeof data.max === 'number' || data.max === null) &&
    (typeof data.min === 'number' || data.min === null)
  );
}

export function isPartNoList(data: any): data is PartNoList {
  return data && isArray(data) && data.every((e: any) => typeof e === 'string');
}

export function isGetOperationHistoryList(
  data: any,
): data is GetOperationHistory {
  return (
    data &&
    typeof data.totalRows === 'number' &&
    isArray(data.operationHistoryList) &&
    data.operationHistoryList.every((e: any) => isGetOperationHistory(e))
  );
}

function isGetOperationHistory(data: any): data is GetOperationHistory {
  return (
    data &&
    typeof data.rmaNo === 'string' &&
    typeof data.serialNo === 'string' &&
    typeof data.time === 'string' &&
    typeof data.userId === 'string' &&
    typeof data.status === 'number' &&
    typeof data.type === 'number' &&
    typeof data.item === 'string'
  );
}

export function isGetModelNameList(data: any): data is GetModelNameList {
  return data && isArray(data) && data.every((e: any) => typeof e === 'string');
}
